import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Alert, Box } from '@mui/material';

import type { CfiReport } from '~/data/hooks/useCfi';

import { CfiDownloadButton } from './CfiDownloadButton';
import { CfiIntro } from './CfiIntro';
import { PROSE_MAX_WIDTH_WIDE } from './cfiLayout';

type Props = {
  report: CfiReport | null;
  /** See `cfiLayout` — the full-page view gives the prose a longer line. */
  wide?: boolean;
};

/** Read-only CFI view for client (non-consultant) users. They cannot run, edit,
 * or approve a report — they only view the published report (opens in a new tab,
 * printable to PDF) once a consultant has published one, and otherwise see a
 * prompt to ask their consultant. */
export const CfiClientView = ({ report, wide = false }: Props) => {
  const published = report?.status === 'published' ? report : null;

  return (
    <Box sx={{ maxWidth: wide ? PROSE_MAX_WIDTH_WIDE : 640, mx: 'auto' }}>
      <CfiIntro />
      {published ? (
        <Box sx={{ py: 2 }}>
          <CfiDownloadButton
            reportId={published.id}
            label="View report"
            startIcon={<OpenInNewIcon />}
          />
        </Box>
      ) : (
        <Alert severity="info" sx={{ mt: 2 }}>
          No ContractIQ report has been published for this contract yet. Ask your consultant to
          create one using LAI support.
        </Alert>
      )}
    </Box>
  );
};
